/** Marks that we arrived on this client by switching from a related profile. */
export const RELATED_FROM_QUERY_KEY = 'relatedFrom';

export function formatRelatedPersonName(
    firstname?: string | null,
    lastname?: string | null
): string {
    return [firstname, lastname]
        .filter((part): part is string => typeof part === 'string' && part.trim().length > 0)
        .map((part) => part.trim())
        .join(' ');
}

/**
 * The switcher always labels the other person: spouse when viewing the original
 * client, original client when viewing the spouse.
 */
export function getRelatedSwitcherName(args: {
    fallback: string;
    isRelatedProfileActive: boolean;
    originatingClientName: string;
    spouseName: string;
}): string {
    const preferred = args.isRelatedProfileActive ? args.originatingClientName : args.spouseName;
    return preferred || args.fallback;
}
